import React, { useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Label, Button } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

const InternshipStructureModal = ({
  modal,
  toggle,
  isEdit,
  internshipStructure,
  internshipServices = [],
  onSubmit
}) => {

  // 🔹 Préparer les options pour react-select
  const serviceOptions = internshipServices.map(service => ({
    value: service.id,
    label: service.name
  }));

  // 🔹 Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: internshipStructure?.id || "",
      name: internshipStructure?.name || "",
      region: internshipStructure?.region || "",
      district: internshipStructure?.district || "",
      municipality: internshipStructure?.municipality || "",
      neighborhood: internshipStructure?.neighborhood || "",
      internship_service_ids: internshipStructure?.services
        ? internshipStructure.services.map(s => s.id)
        : []
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Veuillez saisir le nom"),
      internship_service_ids: Yup.array()
        .min(1, "Sélectionnez au moins un service")
        .required("Champ obligatoire")
    }),
    onSubmit: values => {
      const payload = {
        ...values,
        internship_service_ids: values.internship_service_ids.map(Number)
      };
      onSubmit(payload);
      //formik.resetForm();

      
    }
  });

  return (
    <Modal isOpen={modal} toggle={toggle} backdrop="static">
      <ModalHeader toggle={toggle}>
        {isEdit ? "Modifier - Structure de stage" : "Ajouter - Structure de stage"}
      </ModalHeader>
      <ModalBody>
        <form onSubmit={formik.handleSubmit}>
          <Row>
            <Col className="col-12">
              <div className="mb-3">
                <Label>Nom</Label>
                <input
                  type="text"
                  name="name"
                  className={`form-control ${formik.touched.name && formik.errors.name ? "is-invalid" : ""}`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  placeholder="Nom"
                />
                {formik.touched.name && formik.errors.name && (
                  <div className="invalid-feedback">{formik.errors.name}</div>
                )}
              </div>

              <div className="mb-3">
                <Label>Région</Label>
                <input
                  type="text"
                  name="region"
                  className="form-control"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.region}
                  placeholder="Région"
                />
              </div>

              <div className="mb-3">
                <Label>Cercle</Label>
                <input
                  type="text"
                  name="district"
                  className="form-control"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.district}
                  placeholder="Cercle"
                />
              </div>

              <div className="mb-3">
                <Label>Commune</Label>
                <input
                  type="text"
                  name="municipality"
                  className="form-control"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.municipality}
                  placeholder="Commune"
                />
              </div>

              <div className="mb-3">
                <Label>Quartier</Label>
                <input
                  type="text"
                  name="neighborhood"
                  className="form-control"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.neighborhood}
                  placeholder="Quartier"
                />
              </div>

              <div className="mb-3">
                <Label>Services de stage</Label>
                <Select
                  name="internship_service_ids"
                  options={serviceOptions}
                  isMulti
                  value={serviceOptions.filter(option =>
                    formik.values.internship_service_ids.includes(option.value)
                  )}
                  onChange={selectedOptions => {
                    const values = selectedOptions ? selectedOptions.map(o => o.value) : [];
                    formik.setFieldValue("internship_service_ids", values);
                  }}
                  onBlur={() => formik.setFieldTouched("internship_service_ids", true)}
                />
                {formik.touched.internship_service_ids && formik.errors.internship_service_ids && (
                  <div className="text-danger mt-1">{formik.errors.internship_service_ids}</div>
                )}
              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="text-end">
                <Button type="submit" color="primary">
                  {isEdit ? "Modifier" : "Enregistrer"}
                </Button>
              </div>
            </Col>
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default InternshipStructureModal;
